import type { GrowthCategory, GrowthContent } from '@mc/api'

type CoursesBySubcategory = GrowthCategory & { courses: GrowthContent[] }

export const getNonRepeatingTileOrder = (
  subcategories: GrowthCategory[],
  classes: GrowthContent[],
  currentPageCourseSlug: string,
) => {
  const initialTileSet = new Set()
  const orderedRelatedCoursesBySubcategory: CoursesBySubcategory[] = []

  subcategories.forEach((subcat) => {
    const initialCourses: GrowthContent[] = []

    const coursesInSubcategory = classes.filter((c) =>
      c.subcategories.some((s) => s.id === subcat.id),
    )

    coursesInSubcategory.forEach((course: GrowthContent) => {
      if (initialCourses.length >= 3) {
        return
      }

      if (
        course.slug &&
        currentPageCourseSlug !== course.slug &&
        !initialTileSet.has(course.slug)
      ) {
        initialCourses.push(course)
        initialTileSet.add(course.slug)
      }
    })

    const initialCourseSlugs = initialCourses.map(
      (initialCourse) => initialCourse.slug,
    )

    const otherCourses = coursesInSubcategory.filter(
      (c) => !initialCourseSlugs.includes(c.slug),
    )

    orderedRelatedCoursesBySubcategory.push({
      ...subcat,
      courses: [...initialCourses, ...otherCourses],
    })
  })

  return orderedRelatedCoursesBySubcategory
}
